<template>
  <div id="support" v-loading="loading">
    <div class>
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li class="active">
          <a href="#/sales-resources">Sales Resources</a>
        </li>
      </ol>
    </div>
    <div class="container pb100">
      <div class="row">
        <div class="col-sm-12">
          <p class="text-center font20 mt50 mb0">SALES DOCUMENTATION</p>
        </div>
        <div class="col-md-8 col-md-offset-2 col-sm-12">
          <div class="row text-center mt50">
            <div
              class="col-sm-2 col-sm-25"
              v-for="list of sales_documentation"
              :key="list._id"
            >
              <p class="font16 mb20">{{ list.name }}</p>
              <div
                class="black dl-box font12 h45"
                v-for="(file, index) of list.files"
                :key="index"
              >
                {{ file.name }}
                <p class="act">
                  <a
                    class="mr20 black"
                    target="_blank"
                    :href="(typeof file.file_name != 'undefined' && file.file_name != '') ? $store.state.serverURL + '/' + file.file_name : file.url"
                  >
                    <span class="iconfont3 icon-view font18"></span>
                  </a>
                  <a
                    class="black"
                    v-if="typeof file.file_name != 'undefined' && file.file_name != ''"
                    @click="
                      download(
                        $store.state.serverURL + '/' + file.file_name,
                        file.file_name
                      )
                    "
                  >
                    <span class="iconfont3 icon-download font18"></span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt30" />
      <p class="text-center font20 mt50">DOWNLOADS</p>
      <div class="row">
        <div class="col-md-10 col-md-offset-1 col-sm-12">
          <div class="row mt50 text-center center-box">
            <div class="col-sm-4" v-for="s in downloads" :key="s._id">
              <div class="sale-box dl-box">
                <div class="border inlineb p20">
                  <div
                    class="bg"
                    :style="{
                      backgroundImage:
                        'url(' +
                        $store.state.serverURL +
                        '/' +
                        s.image_file_name +
                        ')',
                    }"
                  ></div>
                </div>
                <p class="mt20">{{ s.name }}</p>
                <p class="act">
                  <a
                    class="mr20 black"
                    target="_blank"
                    :href="(typeof s.file_name != 'undefined' && s.file_name != '') ? $store.state.serverURL + '/' + s.file_name : s.url"
                  >
                    <span class="iconfont3 icon-view font18"></span>
                  </a>
                  <a
                    class="black"
                    v-if="typeof s.file_name != 'undefined' && s.file_name != ''"
                    @click="
                      download($store.state.serverURL + '/' + s.file_name)
                    "
                  >
                    <span class="iconfont3 icon-download font18"></span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt30" />
      <p class="text-center font20 mt50">TUTORIALS AND VIDEOS</p>
      <div class="row">
        <div class="col-md-10 col-md-offset-1 col-sm-12">
          <div class="row mt50 text-center center-box">
            <div class="col-sm-4" v-for="video of videos" :key="video._id">
              <a
                class="video-box inlineb w100"
                :style="{
                  backgroundImage:
                    'url(' +
                    $store.state.serverURL +
                    '/' +
                    video.file_name +
                    ')',
                }"
                href="javascript:void(0);"
                data-toggle="modal"
                data-target="#myModal"
                @click="
                  videoUrl = video.url;
                  videoThumbnail = video.file_name;
                "
              >
                <div class>
                  <img src="../assets/images/icon11.png" alt />
                </div>
              </a>
              <div class="h70">
                <p class="mb0 mt10">{{ video.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade downl"
      id="myModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="
                videoUrl = '';
                videoThumbnail = '';
              "
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                :src="videoUrl"
                border="0"
                :style="{
                  'background-repeat': 'no-repeat',
                  'background-size': '100%',
                  backgroundImage:
                    'url(' +
                    $store.state.serverURL +
                    '/' +
                    videoThumbnail +
                    ')',
                }"
              ></iframe>
              <!-- <video
                preload="none"
                :src="videoUrl"
                controls="controls"
                poster="../assets/images/footer-bg.jpg"
                id="video-content"
              ></video>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "../assets/css/download.css";
export default {
  name: "support",
  data() {
    return {
      loading: true,
      downloads: [],
      sales_documentation: [],
      videos: [],
      videoUrl: "",
      videoThumbnail: "",
      newsImg: require("../assets/images/footer-bg.jpg"),
      news2: require("../assets/images/dl4.jpg"),
      news3: require("../assets/images/dl5.jpg"),
    };
  },
  methods: {
    async download(file, fileName) {
      this.loading = true;
      try {
        var response = await axios(file, { responseType: "blob" });
        var blob = response.data;
        this.loading = false;
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          if (link.download !== undefined) {
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      } catch (err) {
        this.loading = false;
        window.console.log(err);
      }
    },
    async get_sales() {
      return await axios.get("/support/sales");
    },
    async get_downloads() {
      return await axios.get("/support/sales/downloads");
    },
    async get_videos() {
      return await axios.get("/support/sales/videos");
    },
    async set_support() {
      var vals = await Promise.all([this.get_sales(), this.get_downloads(), this.get_videos()]);
      this.downloads = vals[1].data;
      this.sales_documentation = vals[0].data;
      this.videos = vals[2].data;
    },
  },
  async mounted() {
    this.set_support();
    this.loading = false;
  },
};
</script>

<style>
</style>
